"use strict";

function helper(Handlebars) {
  /**
   * Define helper. Set the value of a key in a data context.
   * Uses dot notation for keys
   * If a portion of path does not exist it is created.  Existing objects/arrays are not overwritten
   * @param  {String} ks  dot notation for the key. ie "a.b.c"
   * @param  {String} value value to set
   */
  function defineContext(ks, value) {
    if (!ks) return;
    var keys = ks.split('.');
    var subContext = this;
    var key;
    // Go deep down the context following the keys
    for (var i = 0; i < keys.length - 1; i += 1) {
      key = keys[i];

      // if null or undefined, then create an object to put next key on
      if (subContext[key] === null || typeof subContext[key] === 'undefined') {
        subContext[key] = {};

        // if array or object encountered, no overwriting allowed
      } else if (Object.prototype.toString.call(subContext[key]) === '[object Array]' || subContext[key].constructor !== Object) {
        return;
      }

      // traverse down
      subContext = subContext[key];
    }

    // Finally, on the last key set the value
    key = keys[keys.length - 1];
    subContext[key] = value;
  }
  Handlebars.registerHelper('define', defineContext);
  return defineContext;
}
module.exports = helper;
